export default __webpack_public_path__ + "static/datacenter-d34663fb59881e4ab2e9949e6d114ad3.jpg";